import { combineReducers } from 'redux';
import themeUsersReducer from './themeUsers/reducers';
import { readMessageReducer } from './message/reducers';
import { readNotificationReducer } from './notification/reducers';
import authReducer from './authentication/reducers';
import ChangeLayoutMode from './themeLayout/reducers';
import { teamReducer } from './team/reducers';
import { userReducer, userGroupReducer } from './users/reducers';
import { categoryReducer } from './appCategories/reducers';
import { POSMadaReducer } from './posMadaOps/reducers';
import { sellersReducer } from './sellers/reducers';
import { headerSearchReducer } from './headerSearch/reducers';
import orderReducer from './orders/reducers';
import galleryReducer from './gallary/reducers';
import { emailReducer, SingleEmailReducer } from './email/reducers';
import { productReducer, SingleProductReducer } from './product/reducers';
import { chatReducer, SingleChatReducer, groupChatReducer, SingleChatGroupReducer } from './chat/reducers';
import { projectReducer, SingleProjectReducer } from './project/reducers';
import { axiosCrudReducer, axiosSingleCrudReducer } from './crud/axios/reducers';
import cartData from './cart/reducers';
import Todo from './todo/reducers';
import Note from './note/reducers';
import Task from './task/reducers';
import kanbanBoardReducer from './kanban/reducers';
import Contact from './contact/reducers';
import Profile from './profile/reducers';
import Calender from './calendar/reducers';
import FileManager from './fileManager/reducers';
import tickets from './supportTickets/reducers';
import jobs from './jobs/reducers';
import dataTable from './data-filter/reducers';
import { bannerReducer } from './banners/reducers';
import { brandReducer } from './brands/reducers';
import { stockReducer } from './stock/reducers';
import { merchantBonusesReducer } from './merchantBonuses/reducers';
import { merchantGroupReducer } from './merchantGroups/reducers';
import { salesReducer } from './sales/reducers';
import { suppliersReducer } from './suppliers/reducers';
import { regionsReducer } from './regions/reducers';
import { walletsReducer } from './wallet/reducers';
import { devicesReducer } from './devices/reducers';
import { bitaqatyReducer } from './bitaqaty/reducers';
import { refillBalanceReducer } from './refillBalance/reducers';
import { qwikReducer } from './qwik/reducers';
import { daleelStoreReducer } from './daleelStore/reducers';
import { paynetReducer } from './paynet/reducers';
import { appConfigsReducer } from './appConfigs/reducers';
import { loyaltyPointsLevelsReducer } from './loyaltyPoints/reducers';
import { MadaReconciliationReducer } from './madaReconciliation/reducers';

const rootReducers = combineReducers({
  themeUsers: themeUsersReducer,
  headerSearchData: headerSearchReducer,
  message: readMessageReducer,
  notification: readNotificationReducer,
  orders: orderReducer,
  sellers: sellersReducer,
  users: userReducer,
  categories: categoryReducer,
  devices: devicesReducer,
  banners: bannerReducer,
  brands: brandReducer,
  suppliers: suppliersReducer,
  regions: regionsReducer,
  refillBalance: refillBalanceReducer,
  wallet: walletsReducer,
  posMadaOperations: POSMadaReducer,
  madaReconciliation: MadaReconciliationReducer,
  userGroup: userGroupReducer,
  sales: salesReducer,
  bitaqaty: bitaqatyReducer,
  daleelStore: daleelStoreReducer,
  paynet: paynetReducer,
  qwik: qwikReducer,
  appConfigs: appConfigsReducer,
  loyaltyPoints: loyaltyPointsLevelsReducer,
  team: teamReducer,
  auth: authReducer,
  gallery: galleryReducer,
  email: emailReducer,
  emailSingle: SingleEmailReducer,
  products: productReducer,
  merchantGroups: merchantGroupReducer,
  merchantBonuses: merchantBonusesReducer,
  product: SingleProductReducer,
  chatSingle: SingleChatReducer,
  chatSingleGroup: SingleChatGroupReducer,
  chat: chatReducer,
  groupChat: groupChatReducer,
  projects: projectReducer,
  project: SingleProjectReducer,
  ChangeLayoutMode,
  cart: cartData,
  Todo,
  Note,
  AxiosCrud: axiosCrudReducer,
  Task,
  KanbanBoard: kanbanBoardReducer,
  Contact,
  Profile,
  Calender,
  FileManager,
  tickets,
  jobs,
  dataTable,
  SingleAxiosCrud: axiosSingleCrudReducer,
  stock: stockReducer,
});

export default rootReducers;
